import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

/* On-demand side sheet: closed by default, one at a time, modal dialog semantics (focus trap, Escape, inert background, focus restore). */
export function Sheet({ open, title, onClose, children, testid }: { open: boolean; title: React.ReactNode; onClose: () => void; children: React.ReactNode; testid?: string }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const prev = document.activeElement as HTMLElement | null;
    const main = document.querySelector(".shell") as HTMLElement | null;
    main?.setAttribute("inert", "");
    const first = ref.current?.querySelector<HTMLElement>("button, [href], input, select, textarea");
    first?.focus();
    const key = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
      if (e.key === "Tab" && ref.current) {
        const f = Array.from(ref.current.querySelectorAll<HTMLElement>("button, [href], input, select, textarea")).filter((x) => !x.hasAttribute("disabled"));
        if (!f.length) return;
        const a = f[0], z = f[f.length - 1];
        if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
      }
    };
    document.addEventListener("keydown", key);
    return () => { document.removeEventListener("keydown", key); main?.removeAttribute("inert"); prev?.focus(); };
  }, [open, onClose]);
  if (!open) return null;
  return createPortal(<>
    <div className="sheet-scrim" onClick={onClose} data-testid={`${testid || "sheet"}-scrim`} />
    <aside className="sheet" role="dialog" aria-modal="true" aria-label={typeof title === "string" ? title : "Detail"} ref={ref} data-testid={testid || "sheet"}>
      <header><span>{title}</span><button className="ghost" onClick={onClose} aria-label="Close panel" data-testid={`${testid || "sheet"}-close`}>Close</button></header>
      <div className="sheet-body">{children}</div>
    </aside>
  </>, document.body);
}
